import React, { useCallback, useEffect, useState } from 'react'
import { Button, Card, Table } from 'react-bootstrap'
import CreateAdBannerModal from './components/CreateAdBannerModal'
import config from '../../config'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import moment from 'moment'

export const AD_BANNER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
}

const AdBanner = () => {
  const [adBanners, setAdBanners] = useState([])
  const [selectedAdBanner, setSelectedAdBanner] = useState(null)
  const [isShowModal, setIsShowModal] = useState(false)

  const fetchAdBanners = useCallback(async () => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/configs/banners`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((res) => res.json())

      if (response.status.code !== 0) throw new Error('Error fetching adBanners')

      setAdBanners(response.data)
    } catch {
      Swal.fire({
        title: 'เกิดข้อผิดพลาดระหว่างดึงข้อมูลแบนเนอร์',
        text: 'กรุณาลองใหม่อีกครั้ง',
        icon: 'error',
      })
    }
  }, [])

  useEffect(() => {
    fetchAdBanners()
  }, [fetchAdBanners])

  const handleClickCreateAdBanner = () => {
    setSelectedAdBanner(null)
    setIsShowModal(true)
  }

  const handleClickShowImage = (imageUrl) => {
    Swal.fire({
      imageUrl,
      imageAlt: 'รูปภาพแบนเนอร์',
      confirmButtonText: 'ปิด',
    })
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title>AdBanner</Card.Title>
        <Button variant="info light" onClick={handleClickCreateAdBanner}>
          สร้างแบนเนอร์ใหม่
        </Button>
      </Card.Header>
      <Card.Body>
        <Table responsive bordered hover className="text-center">
          <thead>
            <tr>
              <th>รูปภาพ (Mobile)</th>
              <th>รูปภาพ (Desktop)</th>
              <th>ลิ้งค์</th>
              <th>วันที่สร้าง</th>
              <th>สถานะ</th>
              <th>แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {adBanners &&
              adBanners.map((adBanner, i) => {
                if (!adBanner?.id) return null
                return (
                  <tr key={i}>
                    {
                      adBanner.images.length > 0 &&
                      adBanner.images.map(image => (
                        <td>
                          <Button
                            variant="primary light"
                            onClick={() => {
                              handleClickShowImage(image.url)
                            }}
                          >
                            <i className="fa fa-image mr-1" />
                          </Button>
                        </td>
                      ))
                    }
                    <td>{adBanner.redirectUrl.url}</td>
                    <td>{moment(adBanner.createdAt).format('DD/MM/YYYY HH:mm')}</td>
                    <td className={adBanner.status === AD_BANNER_STATUS.ACTIVE ? 'text-success' : 'text-danger'}>
                      {adBanner.status}
                    </td>
                    <td>
                      <Button
                        variant="primary light"
                        onClick={() => {
                          setSelectedAdBanner(adBanner)
                          setIsShowModal(true)
                        }}
                      >
                        <i className="fa fa-pencil"></i>
                      </Button>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </Table>
      </Card.Body>

      {isShowModal && (
        <CreateAdBannerModal
          show={isShowModal}
          selectedAdBanner={selectedAdBanner}
          handleCloseModal={() => setIsShowModal(false)}
          onCreatedAdBanner={() => {
            setIsShowModal(false)
            fetchAdBanners()
          }}
        />
      )}
    </Card>
  )
}

export default AdBanner
